import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Catalog } from '../../../models/catalog/catalog';
import { CatalogService } from '../../../models/catalog/catalogService';
import { FormMode } from '../../../core/constants';
import { CatalogItem } from '../../../models/catalog/catalogItem';
import { AddCatalogItemDialogComponent } from '../dialogs/add-catalog-item-dialog/add-catalog-item-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { EditCatalogItemDialogComponent } from '../dialogs/edit-catalog-item-dialog/edit-catalog-item-dialog.component';

@Component({
  selector: 'app-edit-catalog',
  standalone: false,
  templateUrl: './edit-catalog.component.html',
})
export class EditCatalogComponent {
  @Input() mode: FormMode = FormMode.View;
  @Input() merchantId: string = '';
  @Input() catalogId: string = '';
  @Input() catalogNames: string[] = [];
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  oldName: string = '';
  oldDescription: string = '';
  FormMode = FormMode;
  catalog: Partial<Catalog> = Catalog.createEmpty();

  constructor(
    private catalogService: CatalogService,
    public addCatalogItemDialog: MatDialog,
  ) {}

  public resetForm() {
    this.catalog = Catalog.createEmpty();
    this.catalogId = '';
  }

  ngOnInit(): void {
    if (!this.merchantId) {
      throw new Error('Merchant ID is required');
    }
    if (this.catalogId) {
      this.catalogService.getCatalog(this.catalogId).then((catalog) => {
        this.catalog = catalog;
        this.oldName = catalog.name ?? '';
        this.oldDescription = catalog.description ?? '';
        this._reloadItemsFromSystem() 
      });
    }
  }

  btnSave_click() {
    if (this.catalogId) {
      this.catalogService.saveCatalog(this.catalog).then(() => {
        this.saved.emit();
        this.oldName = this.catalog.name ?? '';
        this.oldDescription = this.catalog.description ?? '';
      });
    } else {
      this.catalog.merchantId = this.merchantId;
      this.catalogService.createCatalog(this.catalog).then(() => {
        this.saved.emit();
      });
    }
  }

  btnCancel_click() {
    this.cancelled.emit();
  }

  btnAddItem_click() {
    let dialogRef = this.addCatalogItemDialog.open(
      AddCatalogItemDialogComponent,
      {
        width: 'auto',
        maxWidth: '400px',
        disableClose: false,
        data: {
          catalogId: this.catalogId,
        },
      },
    );
    dialogRef.afterClosed().subscribe((result) => {
      this._reloadItemsFromSystem();
    });
  }

  btnEditItem_click(itemId: string | undefined) {
    let dialogRef = this.addCatalogItemDialog.open(
      EditCatalogItemDialogComponent,
      {
        width: 'auto',
        maxWidth: '400px',
        disableClose: false,
        data: {
          itemId: itemId,
          catalogId: this.catalogId,
        },
      },
    );
    dialogRef.afterClosed().subscribe((result) => {
      this._reloadItemsFromSystem();
    });
  }

  btnDeleteItem_click(itemId: string | undefined) {
    if (
      itemId &&
      itemId != '' &&
      confirm('Are you sure you want to delete this item?')
    ) {
      this.catalogService.deleteCatalogItem(itemId).then(() => {
        this._reloadItemsFromSystem();
      });
    }
  }

  _reloadItemsFromSystem() {
    this.catalogService
      .getAllCatalogItems(this.catalogId)
      .then((items: CatalogItem[]) => {
        this.catalog.items = items;
      });
  }
}
